import type { Project, ProjectContract } from '~/types/models';

/** A project attachment is the same agreement only when its recorded source and signed version match. */
export function isLinkedClientContract(project: Project, clientId: string, contract: ProjectContract | null | undefined): boolean {
    const source = (project as Project & { contractSource?: { scope?: string; clientId?: string; version?: number } }).contractSource;
    return Boolean(contract?.status === 'signed' && contract.signedDocumentHash
        && project.clientId === clientId
        && source?.scope === 'client' && source.clientId === clientId && source.version === contract.version
        && project.contract?.status === 'signed' && project.contract.version === contract.version
        && project.contract.signedDocumentHash === contract.signedDocumentHash);
}
